import { render, staticRenderFns } from "./s65T.vue?vue&type=template&id=09d90e24&scoped=true&"
import script from "./s65T.vue?vue&type=script&lang=js&"
export * from "./s65T.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d90e24",
  null
  
)

export default component.exports